'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$FileContent(name, content) {
  this.ZF = null;
  this.ZE = null;
  this.ZF = name;
  this.ZE = content;
}
export { $c_Lpresto_types$proto$FileContent as $c_Lpresto_types$proto$FileContent };
$p = $c_Lpresto_types$proto$FileContent.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$FileContent;
/** @constructor */
function $h_Lpresto_types$proto$FileContent() {
}
export { $h_Lpresto_types$proto$FileContent as $h_Lpresto_types$proto$FileContent };
$h_Lpresto_types$proto$FileContent.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$proto$FileContent) && ((this.ZF === x$0.ZF) && (this.ZE === x$0.ZE))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "FileContent";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.ZF;
  }
  if ((n === 1)) {
    return this.ZE;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$FileContent(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lc)));
}
export { $isArrayOf_Lpresto_types$proto$FileContent as $isArrayOf_Lpresto_types$proto$FileContent };
var $d_Lpresto_types$proto$FileContent = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$FileContent, "presto.types$proto$FileContent", ({
  lc: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$FileContent as $d_Lpresto_types$proto$FileContent };
//# sourceMappingURL=presto.types$proto$-File-Content.js.map
